var hs = hs || {};

hs.util = (function() {

    // 去除字符串的左右空格
    // str 要处理的字符串
    // [type]类型：l:去除左边的空白; r:去除右边空白; b:去掉两边的空白
    var trim = function(str, type) {
        var type = type || "b";
        if (type === "b") {
            return str.replace(/^\s*|\s*$/g, "");
        } else if (type === "l") {
            return str.replace(/^\s*/g, "");
        } else if (type === "r") {
            return str.replace(/\s*$/g, "");
        } else if (type === "a") {
            return str.replace(/\s*/g, "");
        }
    };

    // 数字类型
    var filterInt = function(value) {
        if (/^(\-|\+)?([0-9]+|Infinity)$/.test(value)) {
            return Number(value);
        }
        return NaN;
    };

    // 通用唯一识别码(Universally Unique IDentifier)
    var uuid = function() {
        var d = Date.now();
        if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
            d += performance.now(); //use high-precision timer if available
        }
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    };

    // 展开折叠
    var foldUnfold = function(element, isFold) {
        var $ele = $(element);
        var $parentInit = $ele.parents(".fold-unfold");
        var $stateInit = $ele.find(".current-state");

        isFold = isFold || false;
        // 给我展开
        function _unfold($parent, $state) {
            $parent.addClass("info-unfold").removeClass("info-fold");
            $state.html("收起");
        }
        // 给我收起来
        function _fold($parent, $state) {
            $parent.addClass("info-fold").removeClass("info-unfold");
            $state.html("展开");
        }

        $parentInit.removeClass("info-unfold").removeClass("info-fold");

        if (isFold) {
            _fold($parentInit, $stateInit);

        } else {
            _unfold($parentInit, $stateInit);
        }

        $ele.on("click", function() {
            var $this = $(this);
            var $parent = $this.parents(".fold-unfold");
            var $state = $this.find(".current-state");

            isFold = $parent.hasClass("info-unfold");

            if (isFold) {
                _fold($parent, $state);
                isFold = false;
            } else {
                _unfold($parent, $state);
                isFold = true;
            }
        });
    };

    // 为item添加点击激活{parent:'.parent', item:'.item', active:'active'}
    var itemActive = function(param) {
        $(param.parent).on('click', param.item, function() {
            var $this = $(this);
            $this.addClass(param.active).siblings().removeClass(param.active);
        });
    };

    var selfActive = function(item, activeClass) {
        $(item).on('click', function() {
            var $this = $(this);
            $this.hasClass(activeClass) ? $this.removeClass(activeClass) : $this.addClass(activeClass);
        });
    };

    // 进入离开相关激活{item:'.input', active:'active'}
    var itemEnterLeave = function(param) {
        $(param.item).on({
            mouseenter: function() {
                $(this).addClass(param.active);
            },
            mouseleave: function() {
                $(this).removeClass(param.active);
            }
        });
    };

    // 等高 '[data-equal="col"]'
    var equalHeight = function(item) {
        var $item = $(item);
        var maxHeight = 0;
        $item.each(function() {
            var height = $(this).innerHeight();
            if (height > maxHeight) {
                maxHeight = height;
            }
        });
        $item.css({
            height: maxHeight
        });
    };

    // 收藏操作
    var favoritePopup = function(item, activeClass) {
        $(item).on('click', function() {
            var $this = $(this);
            if ($this.hasClass(activeClass)) {
                $this.removeClass(activeClass).find('.iconfont').remove().end().prepend('<i class="iconfont icon-favorite"></i>');
                autoHide({
                    content: "取消收藏"
                });
            } else {
                $this.addClass(activeClass).find('.iconfont').remove().end().prepend('<i class="iconfont icon-favorite-active"></i>');
                autoHide({
                    content: "收藏成功"
                });
            }
        });
    };

    var favorite = function(item, activeClass) {
        $(item).on('click', function() {
            var $this = $(this);
            if ($this.hasClass(activeClass)) {
                $this.removeClass(activeClass).find('.iconfont').remove().end().prepend('<i class="iconfont icon-favorite"></i>').find('.info').html("收藏");
            } else {
                $this.addClass(activeClass).find('.iconfont').remove().end().prepend('<i class="iconfont icon-favorite-active"></i>').find('.info').html("已收藏");
            }
        });
    };

    var tagToggle = function(param) {

        var $item = $(param.item);
        var activeClass = param.activeClass || 'tag-operate_active';
        var iconClass = param.iconClass || 'iconfont';
        var nameClass = param.nameClass || 'tag-operate__name';

        var countClass = param.countClass || 'tag-operate__count';
        var count = param.icon || 'data-count';

        var icon = param.icon || 'data-icon';
        var iconActive = param.iconActive || 'data-icon-active';

        var name = param.name || 'data-name';
        var nameActive = param.nameActive || 'data-name-active';
        var nameHover = param.nameHover || 'data-name-hover';

        iconClass = '.' + iconClass;
        nameClass = '.' + nameClass;
        countClass = '.' + countClass;

        $item.on({
            mouseenter: function() {
                var $this = $(this);
                var dataNameHover = $this.attr(nameHover);
                var $name = $this.find(nameClass);
                // 激活状态时提示取消操作
                $this.hasClass(activeClass) && $name.length && dataNameHover && $name.html(dataNameHover);
            },
            mouseleave: function() {
                var $this = $(this);
                var dataNameHover = $this.attr(nameHover);
                var dataNameActive = $this.attr(nameActive);
                var $name = $this.find(nameClass);
                // 离开时仍是激活状态则恢复到激活状态
                $this.hasClass(activeClass) && $name.length && dataNameHover && $name.html(dataNameActive);
            }
        });

        $item.on('click', function() {
            var $this = $(this);
            var dataIcon = $this.attr(icon);
            var dataIconActive = $this.attr(iconActive);
            var dataName = $this.attr(name);
            var dataNameActive = $this.attr(nameActive);

            var $icon = $this.find(iconClass);
            var $name = $this.find(nameClass);
            var $count = $this.find(countClass);

            var iconLen = $icon.length;
            var nameLen = $name.length;
            var countLen = $count.length;

            var total = filterInt($count.text()) || filterInt($this.attr(count)) || 0;

            if ($this.hasClass(activeClass)) {
                $this.removeClass(activeClass);
                iconLen && $icon.html(dataIcon);
                nameLen && $name.html(dataName);
                countLen && $count.text(--total);
                countLen && $this.attr(count, total);
            } else {
                $this.addClass(activeClass);
                iconLen && $icon.html(dataIconActive);
                nameLen && $name.html(dataNameActive);
                countLen && $count.text(++total);
                countLen && $this.attr(count, total);
            }
        });
    };

    // 返回操作
    var navBack = function(e) {
        window.history.go(-1);
        e.preventDefault();
    };

    // 弹出层自动隐藏，依赖layer.js
    var autoHide = function(param) {
        layer.msg(param.content, {
            time: 1000
        });
    };

    // 第一个子元素加first, 最后一个元素加last
    var firstLast = function(item, firstClass, lastClass) {
        firstClass = firstClass || 'first';
        lastClass = lastClass || 'last';
        $(item).filter(":nth-child(1)").addClass(firstClass).end().filter(":nth-last-child(1)").addClass(lastClass);
    };

    // 无链接地址
    var linkNull = function(param) {
        $(param.parent).on('click', param.item || '', function(e) {
            if ($(this).attr('href') === "#" || $(this).attr('href') === "") {
                e.preventDefault();
            }
        });
    };

    var linkGo = function(item) {
        $(item).on('click', function() {
            var $this = $(this);
            var urlBlank = $this.attr("data-link");
            var urlTemp = $this.attr("data-url");
            if (urlBlank === "_blank") {
                window.open(urlTemp, '_blank');
            } else {
                location.href = urlTemp;
            }
        });
    };

    /**
     * 生成二维码
     *
     * 依赖 https://cdn.bootcss.com/jquery.qrcode/1.0/jquery.qrcode.min.js
     *
     * 调用方法一:　就只有一个空层，传入配置参数
     * html: <div class="j_qr"></div>
     * js: util.makeQR({ item:'.j_qr', qrInfo='扫描要显示的内容', qrWidth='128', qrHeight='128' });
     *
     * 调用方法二（推荐）: 标签上配置 data- 属性
     * html: <div class="j_qr" data-qrheight="128" data-qrwidth="128" data-qrinfo="扫描要显示的内容"></div>
     * js: util.makeQR();
     *
     */

    var _qrRender = "canvas";

    function _isCanvasSupported() {
        $("body").append('<canvas id="J_TestCanvas"></canvas>');
        var elem = document.getElementById("J_TestCanvas");
        $("#J_TestCanvas").remove();
        return !!(elem.getContext && elem.getContext('2d'));
    }

    if (!_isCanvasSupported()) {
        _qrRender = "table";
    }

    var makeQR = function(param) {
        param = param || {};
        var item = param.item || ".j_qr";
        var $item = $(item);
        if ($item.find("canvas").length === 0 || $item.find("table").length === 0) {
            var qrInfo = param.qrInfo || $item.data("qrinfo"),
                qrWidth = param.qrWidth || $item.data("qrwidth"),
                qrHeight = param.qrHeight || $item.data("qrheight");
            $item.qrcode({
                render: _qrRender,
                width: qrWidth,
                height: qrWidth,
                text: qrInfo
            });
        }
    };

    return {
        trim: trim,
        filterInt: filterInt,
        uuid: uuid,
        foldUnfold: foldUnfold,
        itemActive: itemActive,
        selfActive: selfActive,
        itemEnterLeave: itemEnterLeave,
        equalHeight: equalHeight,
        favorite: favorite,
        favoritePopup: favoritePopup,
        navBack: navBack,
        autoHide: autoHide,
        firstLast: firstLast,
        linkNull: linkNull,
        linkGo: linkGo,
        makeQR: makeQR,
        tagToggle: tagToggle
    };
}());

(function($) {
    // $('.demo').exist()
    $.fn.exist = function() {
        return this.length;
    };
})(jQuery);